import { render, staticRenderFns } from "./faturacao-anuladas.vue?vue&type=template&id=71d7ce5e&scoped=true&"
import script from "./faturacao-anuladas.vue?vue&type=script&lang=js&"
export * from "./faturacao-anuladas.vue?vue&type=script&lang=js&"
import style0 from "./faturacao-anuladas.vue?vue&type=style&index=0&id=71d7ce5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7ce5e",
  null
  
)

export default component.exports